import http, { addTokenAndKeyParams } from '@/utils/http'

export const getArticleList = data => {
  return http({
    url: '/qxtx/app/getArticleCategoryList',
    method: 'post',
    data:addTokenAndKeyParams(data),
  })
}

export const getArticleDetail = data => {
  return http({
    url: '/qxtx/app/getArticleList',
    method: 'post',
    data:addTokenAndKeyParams(data),
  })
}

export const getVipInfo = data => {
  return http({
    url: '/m/myvipinfo.json',
    method: 'post',
    data:addTokenAndKeyParams(data),
  })
}

export const getUsegift = data => {
  return http({
    url: '/m/usegift.json',
    method: 'post',
    data:addTokenAndKeyParams(data),
  })
}

// export const getBanner = data => {
//   data.type = 1;
//   return http({
//     url: '/qxtx/h5/index/listBannerImage',
//     method: 'post',
//     data:addTokenAndKeyParams(data),
//     isFromQxtx:true
//   })
// }
// export const getGoodsList = data => {
//   return http({
//     url: '/qxtx/h5/index/listItems',
//     method: 'post',
//     data:addTokenAndKeyParams(data),
//     isFromQxtx: true
//   })
// }
